// ./routes/index.ts
const paths = {
  // Auth
  login: "/login",
  signIn: "/sign-in",

  // Common
  projectDetails: "/project-details/:projectId",
  toProjectDetails: (projectId: string) => `/project-details/${projectId}`,

  courses: "/courses",
  myCourses: "/my-courses",
  viewCourse: "/view-course/:courseId",
  toViewCourse: (courseId: string) => `/view-course/${courseId}`,
  courseDetails: "/my-courses/course-details/:contextId",
  toCourseDetails: (contextId: string) =>
    `/my-courses/course-details/${contextId}`,
  pageContent: "/course/:contextId/page",
  toPageContent: (contextId: string, moduleId: string, moduleName: string) =>
    `/course/${contextId}/page?moduleId=${moduleId}&moduleName=${encodeURIComponent(moduleName)}`,

  quizLanding: "/course/:contextId/quiz/:moduleId",
  toQuizLanding: (contextId: string, moduleId: string) =>
    `/course/${contextId}/quiz/${moduleId}`,

  lessonContent: "/course/:contextId/lesson",
  toLessonContent: (contextId: string, moduleId: string, moduleName: string) =>
    `/course/${contextId}/lesson?moduleId=${moduleId}&moduleName=${encodeURIComponent(moduleName)}`,

  bookContent: "/course/:contextId/book",
  toBookContent: (contextId: string, moduleId: string, moduleName: string) =>
    `/course/${contextId}/book?moduleId=${moduleId}&moduleName=${encodeURIComponent(moduleName)}`,

  viewAllProjects: "/view-all-project",
  instructorProjectDetails: "/view-project-details/:projectId",

  viewStudent: "/view-student/:studentId",
  toViewStudent: (studentId: string) => `/view-student/${studentId}`,

  gradebook: "/gradebook",
  communication: "/communication",
  submissions: "/submissions",

  // Student
  notebook: "/notebook/:projectId",
  notebooks: "/notebooks/:projectId",
  allProjects: "/allprojects",
  datasets: "/datasets/:projectId",
  pythonScripts: "/scripts/:projectId",
  // Instructor/Admin
  timeExtensions: "/time-extensions",
  studentNotebook: "/student-notebook",
  modelTesting: "/model-testing",
  viewStudentCode: "/view-student-code",
  submissionDetails: "/submission-details/:submissionId",
  userManagement: "/user-management",
  sandboxManagement: "/sandbox-management",
  gradingSandbox: "/grading-sandbox",
  grading: "/grading",
  createProject: "/create-project",
  editProject: "/edit-project/:projectId",
  toEditProject: (projectId: string) => `/edit-project/${projectId}`,
  useTemplate: "/use-template",
  manageProjects: "/app/manage-projects",
  dataSet: "/data-set",
  createDataSet: "/create-data-set",
  viewDataset: "/view-dataset/:datasetId",
  toViewDataset: (datasetId: string) => `/view-dataset/${datasetId}`,
  studentSubmissions: "/projects/:projectId/submissions/:userId?",

  // Practice Projects
  practiceProjects: "/practice-projects",
  practiceProjectsManagement: "/practice-projects/management",
  createPracticeProject: "/practice-projects/create",
  editPracticeProject: "/practice-projects/edit/:projectId",
  toEditPracticeProject: (projectId: string) =>
    `/practice-projects/edit/${projectId}`,
  practiceProjectDetails: "/practice-projects/:projectId",
  toPracticeProjectDetails: (projectId: string) =>
    `/practice-projects/${projectId}`,
  myPracticeProjects: "/my-practice-projects",
  practiceProjectWorkspace: "/practice-projects/:projectId/workspace",
  toPracticeProjectWorkspace: (projectId: string) =>
    `/practice-projects/${projectId}/workspace`,

  // Admin-only
  rolePermissions: "/role-permissions",
  sandboxAnalytics: "/sandbox-analytics",
  adminProjects: "/admin-projects",
  adminReports: "/admin-reports",
  adminSettings: "/admin-settings",
  adminAudit: "/admin-audit",
  settings: "/settings",
  // Sandbox (all roles)
  sandbox: "/sandbox",
  // Not Found Page
  pageNotFound: "/page-not-found",
  // Misc
  root: "/",
  notFound: "*",
  // AI Chat
  aiChat: "/ai-chat",
};

export default paths;
